import axios from 'axios'

const ApiPlugin = {
  install(Vue) {
    const url = new URL(window.location.href)
    const domain = url.hostname

    const baseUrl = process.env.NODE_ENV === 'development'
      ? process.env.BACKEND_API
      : `https://api.${domain}`

    const api = axios.create({
      baseURL: `${baseUrl}/v2`,
      timeout: 30000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    })

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = api
  },
}

export default ApiPlugin



// WEBPACK FOOTER //
// ./src/lib/api.js